import { render, staticRenderFns } from "./tz.vue?vue&type=template&id=12e5ad78&scoped=true"
import script from "./tz.vue?vue&type=script&lang=js"
export * from "./tz.vue?vue&type=script&lang=js"
import style0 from "./tz.vue?vue&type=style&index=0&id=12e5ad78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5ad78",
  null
  
)

export default component.exports